import React, { useEffect } from "react";
import { trackEvent, ClarityEvents } from "utils/clarity";
import SEOMeta from "components/common/SEOMeta";

const NotFound: React.FC = () => {
  useEffect(() => {
    trackEvent(ClarityEvents.ERROR_PAGE, { path: window.location.pathname });
  }, []);

  return (
    <>
      <SEOMeta title="Page Not Found" noIndex />
      <div>Not Found</div>
    </>
  );
};
export default NotFound;
